export interface PesquisaMenuItem {
  label: string;
  path: string;
  children?: PesquisaMenuItem[];
}

export const pesquisaMenuItems: PesquisaMenuItem[] = [
  {
    label: 'PD&I',
    path: '/pesquisa-inovacao',
  },
  {
    label: 'ICT Senac-AM',
    path: '/ict-senac',
  },
  {
    label: 'Soluções Inovadoras para Empresas',
    path: '/pesquisa-inovacao/solucoes-inovadoras-para-empresas',
  },
  {
    label: 'OBTEC',
    path: '/pesquisa-inovacao/obtec',
  },
  {
    label: 'Vitrine Tecnológica',
    path: '/pesquisa-inovacao/vitrine-tecnologica',
  },
];
